import React from 'react';
import PropTypes from 'prop-types';
import './css/PriceText.css';
import {
  BYN_TEXT,
  RUB_TEXT,
  USD_TEXT,
  EUR_TEXT,
} from '../../Utils/Constants/GlobalConstants';
import { ReactComponent as BynIco } from '../../images/byn-symbol-r.svg';
import { ReactComponent as RubIco } from '../../images/rub-symbol-r.svg';
import { ReactComponent as UsdIco } from '../../images/usd-symbol-r.svg';
import { ReactComponent as EurIco } from '../../images/eur-symbol-r.svg';

const currencyIcons = {
  [BYN_TEXT]: BynIco,
  [RUB_TEXT]: RubIco,
  [USD_TEXT]: UsdIco,
  [EUR_TEXT]: EurIco,
};

// Renders a price string, replacing the currency code with its symbol
function PriceText(props) {
  const { text } = props;
  const value = `${text}`;
  const code = Object.keys(currencyIcons).find((e) => value.includes(e));

  if (!code) {
    return value;
  }

  const index = value.indexOf(code);
  const Icon = currencyIcons[code];

  return (
    <span className="prc_txt">
      {value.slice(0, index)}
      <Icon className="prc_txt_ico" />
      {value.slice(index + code.length)}
    </span>
  );
}

PriceText.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PriceText;
